import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=281cfb20&scoped=true"
import script from "./HomeFooter.vue?vue&type=script&lang=ts"
export * from "./HomeFooter.vue?vue&type=script&lang=ts"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=281cfb20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281cfb20",
  null
  
)

export default component.exports